import React from 'react'
import { useAuth } from '../../hooks/useAuth'

export default function InBrain() {
    const { user } = useAuth();
  return (
    <iframe border="0" width="400px" height="800px" src={`https://www.surveyb.in/configuration?params=Z2lNTU1aQVdIS2VBa0RyQWRIUTI0MTNJem5sc092cUxSNkp4MDY5NXg0NWw0SU15dG9zVVlVaTBDeit6eDlIbGg2ekhpMzh5SWthb0FwQkYyKy9zQkkxU083aUxCWTIwWTdsQUFyWGFNRTNVK3p5ekpRd2ZkanNhL2tpa0xnZ2tzKytrenYxRDA0SFhIOWVKNVo3bHU2bk04dmFrWjJKSHg2VzdqYlFIMjJXQ0M0Q3Nic0NML213MytsbjByMXlKbU91MmYycFk2NUJnT1dTL1Q5eklzSmpXMk01cWFwMHRVRjNycGxEbUtHd3BmenB2dE5EaVJFSUlPUVVmK2l5bQ$app_uid=${user.id}`}></iframe>
  )
}
